module.exports = __webpack_public_path__ + "static/media/bobber-wp.3e944880.jpg";